import styled from 'styled-components'

export const ActionContent = styled.div`
  height: calc(100% - 11px);
  display: flex;
  align-items: center;
  padding: ${props => props.padding ? props.padding : '8px'};
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;
  color: #eee;
  user-select: none;
  margin-left: 15px;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : '#009CA6'};
`

export const ItemColumnCentered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-family: 'Open Sans';
    font-weight: 600;
    margin-top: 5px;
  }

`
